// Logos dos conectores do catálogo (H3, PO1-3261), por `conector.key`. Arquivos em
// src/assets/img/conectores, com a margem em branco aparada (fundo branco; o do OBC
// legado era lilás e foi normalizado). Conector sem entrada aqui cai na sigla (monograma).
import espiao from "../../../assets/img/conectores/espiao.png";
import neogrid from "../../../assets/img/conectores/neogrid.png";
import oracle from "../../../assets/img/conectores/oracle.png";
import protheus from "../../../assets/img/conectores/protheus.png";
import sefaz from "../../../assets/img/conectores/sefaz.png";
import seniorG5 from "../../../assets/img/conectores/senior-g5.png";
import datasul from "../../../assets/img/conectores/datasul.png";
import sapB1 from "../../../assets/img/conectores/sap-b1.png";
import sankhya from "../../../assets/img/conectores/sankhya.png";
import omie from "../../../assets/img/conectores/omie.png";
import bling from "../../../assets/img/conectores/bling.png";
import tiny from "../../../assets/img/conectores/tiny.png";
import v360 from "../../../assets/img/conectores/v360.png";
import comprovei from "../../../assets/img/conectores/comprovei.png";
import simpliroute from "../../../assets/img/conectores/simpliroute.png";

// O conector "obc" (chave histórica) é o Oracle da Tegma/Fastline: usa o logo do Oracle.
// O Protheus saiu dos fixos (PO1-3655): o logo fica só no catálogo de ERPs.
const LOGOS = { espiao, sefaz, obc: oracle, neogrid, v360 };

// Conectores de ERP do catálogo (GET /conectores-erp), por `conectorKey`. O card deles
// tem key `catalogo:<conectorKey>` (statusConectorErp.cardDoCatalogo). O do Senior G5
// (PO1-3559) é o vetor oficial do site da Senior na cor da marca (#00958B). O
// TOTVS Protheus do catálogo (PO1-3562) usa o logo do antigo card fixo; o TOTVS
// Datasul (PO1-3561) usa o mesmo desenho com "DATASUL" no lugar de "PROTHEUS".
// O SAP Business One (PO1-3818) é o vetor oficial da SAP (gradiente azul).
// O Sankhya (PO1-3558) é o vetor oficial do site da Sankhya (símbolo verde #66CB66).
// O Omie (PO1-3844) é o logo oficial da tela de login do app Omie (ciano).
// O Bling (PO1-3845) é o vetor oficial do cabeçalho do site do Bling (#002726).
// O Tiny (PO1-3555) usa o vetor oficial da marca Olist, que hoje assina o tiny.com.br.
// Gestão de entrega (épico PO1-3858): o Comprovei (PO1-3860) é o ícone oficial do site
// comprovei.com; a SimpliRoute (PO1-3861) é o vetor oficial do site simpliroute.com.
export const LOGOS_CATALOGO = {
  "senior-g5": seniorG5,
  "totvs-protheus": protheus,
  "totvs-datasul": datasul,
  "sap-b1": sapB1,
  sankhya,
  omie,
  bling,
  tiny,
  comprovei,
  simpliroute,
};

const PREFIXO_CATALOGO = "catalogo:";

export function logoDoConector(key) {
  if (typeof key === "string" && key.indexOf(PREFIXO_CATALOGO) === 0) {
    return LOGOS_CATALOGO[key.slice(PREFIXO_CATALOGO.length)] || null;
  }
  return LOGOS[key] || null;
}

export default LOGOS;
